export const ProductListingConstants = {
    GET_PRODUCT_LISTING: 'GET_PRODUCT_LISTING',

    GETALL_PRODUCTS_REQUEST: 'GETALL_PRODUCTS_REQUEST',
    GETALL_PRODUCTS_SUCCESS: 'GETALL_PRODUCTS_SUCCESS',
    GETALL_PRODUCTS_FAILURE: 'GETALL_PRODUCTS_FAILURE'
};
